<mat-card class="watch-card">
    <div class="image-and-thumbnails">

        <div class="main-image-container" *ngIf="primaryImageUrls.length > 0; else noImage">
            <button mat-icon-button class="nav-button left" (click)="prevImage()" [disabled]="selectedIndex === 0">
                <mat-icon>chevron_left</mat-icon>
            </button>

            <img *ngFor="let img of primaryImageUrls; let i = index" [src]="img" alt="Principal Image"
                class="main-image" [ngStyle]="getSlideStyle(i)" />

            <button mat-icon-button class="nav-button right" (click)="nextImage()"
                [disabled]="selectedIndex === (primaryImageUrls.length - 1)">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <div class="thumbnail-container">
            <img *ngFor="let image of primaryImageUrls; let i = index" [src]="image" [alt]="'Thumbnail ' + (i + 1)"
                class="thumbnail" [class.selected]="i === selectedIndex" (click)="selectImage(i)" />
        </div>

    </div>

    <div class="watch-info">
        <mat-card-content>

            <div class="tittle-fav-container">
                <h1 class="name">{{ watch?.customTitle }}</h1>
                <button mat-icon-button class="fav-button" (click)="toggleFavorite()">
                    <mat-icon class="jello-horizontal" *ngIf="isFavorite">favorite</mat-icon>
                    <mat-icon class="jello-horizontal" *ngIf="!isFavorite">favorite_border</mat-icon>
                </button>
            </div>
            <p class="short-description">{{ shortDescription }}</p>

            <!-- DETALLES -->
            <div class="watch-details">
                <div class="detail-row">
                    <div class="label">Price:</div>
                    <div class="value">{{ watch?.price | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
                </div>
                <div class="detail-row">
                    <div class="label">Condition:</div>
                    <div class="value">{{ watch?.itemCondition?.name }}</div>
                </div>
                <div class="detail-row">
                    <div class="label">Vendor:</div>
                    <div class="value-nobutton">{{ this.brandName }}</div>
                </div>
                <div class="detail-row">
                    <div class="label">Status:</div>
                    <div class="value">{{ watch?.marketStatus?.name }}</div>
                </div>

                <div class="detail-row">
                    <div class="label">Size:</div>
                    <div class="value">{{ watch?.watchModel?.caseDiameter }} mm</div>
                </div>
                <div class="detail-row">
                    <div class="label">Gender:</div>
                    <div class="value">
                        {{ watch?.watchModel?.genderId === 1 ? 'Male' : watch?.watchModel?.genderId === 2 ?
                        'Female' : 'Unisex' }}
                    </div>
                </div>
                <div class="contact-provider-button">
                    <button mat-stroked-button type="button">
                        Contact seller
                    </button>
                </div>
                <div class="detail-row">
                    <div class="label">Material:</div>
                    <div class="value">{{ caseMaterial }}</div>
                </div>
                <div class="detail-row-shipping">
                    <div class="label">
                        <mat-icon>local_shipping</mat-icon>
                        <span>{{ shippingText }}</span>
                    </div>

                </div>
                <div class="detail-row-views">
                    <div class="label">
                        <mat-icon>visibility</mat-icon>
                        <span>{{ watch?.views }} Visits</span>
                    </div>
                </div>

                <button mat-button class="share-button">
                    <mat-icon>share</mat-icon>
                    <span>Share</span>
                </button>
            </div>

        </mat-card-content>

    </div>
</mat-card>
<!-- TABS DE DESCRIPCIÓN Y REVIEWS -->
<mat-tab-group class="watch-tabs">
    <mat-tab label="Description">
        <div class="descripcion-tab">
            <p>{{ watch?.notes }}</p>
        </div>
    </mat-tab>

    <mat-tab label="Reviews">
        <div class="reviews-tab">
            <p>No reviews yet.</p>

        </div>
    </mat-tab>
</mat-tab-group>


<ng-template #noImage>
    <div class="no-image-container">
        <p class="no-image">No images available</p>
    </div>
</ng-template>